export default __webpack_public_path__ + "static/media/Img5.78af2251.jpg";